import React from 'react';
import { WebsiteDesignProps } from './types';
import { Flag, Globe, MessageSquare } from 'lucide-react';
import { Button } from "@/components/ui/button";

const DiplomaticCorps: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Institute of Diplomacy";

    return (
        <div className="bg-[#f0f4f8] text-[#1a202c] min-h-screen font-serif">
            <nav className="bg-[#0047bb] text-white py-2 px-8 text-xs font-sans font-bold uppercase tracking-widest flex justify-between">
                <span>International Relations</span>
                <div className="flex gap-4">
                    <span>EN</span>
                    <span className="opacity-50">FR</span>
                    <span className="opacity-50">ES</span>
                </div>
            </nav>

            <header className="bg-white border-b border-gray-200 px-8 py-8 shadow-sm">
                <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center gap-4">
                        <Globe size={48} className="text-[#0047bb]" strokeWidth={1} />
                        <div>
                            <h1 className="text-2xl font-bold uppercase tracking-wide text-[#1a202c] leading-none">
                                {schoolName}
                            </h1>
                            <span className="text-xs font-sans text-gray-500 uppercase tracking-widest">Bridging Nations</span>
                        </div>
                    </div>
                    <div className="flex gap-8 font-sans text-sm font-bold uppercase tracking-wide text-gray-600">
                        <a href="#" className="hover:text-[#0047bb]">Policy</a>
                        <a href="#" className="hover:text-[#0047bb]">Research</a>
                        <a href="#" className="hover:text-[#0047bb]">Events</a>
                        <a href="#" className="hover:text-[#0047bb]">Fellows</a>
                    </div>
                </div>
            </header>

            <main className="container mx-auto px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
                    <div>
                        <h2 className="text-4xl md:text-5xl font-medium mb-8 leading-tight text-[#2d3748]">
                            Dialogue in a <br/> Divided World.
                        </h2>
                        <div className="w-16 h-1 bg-[#0047bb] mb-8"></div>
                        <p className="text-lg text-gray-600 mb-8 leading-relaxed font-sans">
                            We train the next generation of ambassadors, negotiators, and peacekeepers. Understanding the nuance of culture, language, and history is paramount to global stability.
                        </p>
                        <Button className="bg-[#0047bb] text-white hover:bg-[#003080] font-sans font-bold uppercase tracking-widest text-xs px-8 py-4 rounded shadow-md">
                            Apply for Fellowship
                        </Button>
                    </div>

                    <div className="bg-white p-8 border border-gray-200 shadow-lg relative">
                        {/* Decorative Flag Strip */}
                        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-red-500 to-green-500"></div>
                        
                        <h3 className="font-sans font-bold uppercase text-gray-500 text-xs tracking-widest mb-6">Latest Briefings</h3>
                        
                        <div className="space-y-6">
                            <div className="pb-6 border-b border-gray-100 last:border-0 last:pb-0">
                                <div className="text-xs font-sans font-bold text-[#0047bb] mb-2 uppercase">Global Summit</div>
                                <h4 className="text-xl font-bold mb-2">Climate Accord Negotiations</h4>
                                <p className="text-sm text-gray-500 font-sans">Analyzing the outcomes of the Geneva talks.</p>
                            </div>
                            <div className="pb-6 border-b border-gray-100 last:border-0 last:pb-0">
                                <div className="text-xs font-sans font-bold text-[#0047bb] mb-2 uppercase">Economic Policy</div>
                                <h4 className="text-xl font-bold mb-2">Trade Routes in the 21st Century</h4>
                                <p className="text-sm text-gray-500 font-sans">Impact on emerging markets and diplomatic ties.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default DiplomaticCorps;
